import { render, staticRenderFns } from "./QrReader.vue?vue&type=template&id=064110d0"
import script from "./QrReader.vue?vue&type=script&lang=js"
export * from "./QrReader.vue?vue&type=script&lang=js"
import style0 from "./QrReader.vue?vue&type=style&index=0&id=064110d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports